export const pushToDatalayer = (event: string, data?: object): void => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: event,
        ...data
    });
};
